import { Outlet } from "react-router-dom";

const PackagesLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default PackagesLayout;
